import styled from 'styled-components'

const BurgerMenuStyle = styled.div`
	--burgerMenuMarinLeft: var(--sp3x);

	margin-left: var(--burgerMenuMarinLeft);

	.openMenu {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 100%;
		background: var(--black);
		z-index: 2;
		transition: var(--trTime2);
		padding: 0 var(--containerPadding);
		display: flex;
		justify-content: center;

		.linkInnerText {
			&.active {
				color: var(--orange);
			}
		}

		.menuRoutes {
			margin-top: var(--sp4x);
			width: fit-content;
		}

		.slotMachineLottie {
			position: absolute;
			right: 5%;
			bottom: 10%;
			width: 38.4%;
		}

		&.active {
			position: fixed;
			left: 0;
			z-index: 2;
		}
	}

	.menu-routes-wrap {
		overflow-y: auto;

		&::-webkit-scrollbar {
			-ms-overflow-style: none;
			scrollbar-width: none;
			overflow-y: scroll;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.slotMachineLottie {
			display: none;
		}
	}

	@media screen and (orientation: landscape) {
		.openMenu {
			padding-top: var(--sp10x);

			.menu-routes-wrap {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;

				.menuRoutes {
					margin-right: var(--sp12x);
				}
			}
		}
	}
`

export default BurgerMenuStyle
